<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "OsobaTvrtkaBase"
};
</script>

<style scoped>

</style>
